/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import useGlobalCompany from "hooks/useGlobalCompany"
import useGlobalTheme from "hooks/useGlobalTheme"
import Microdata from "../../../utils/microdata"

const Seo = ({ title, description, image, doNotIndex, location, ld, data }) => {
  const { sitename } = useGlobalCompany()
  const theme = useGlobalTheme()
  const defaultMetaImage =
    theme.metaImage?.localImage?.childImageSharp?.original?.src

  const metaImage = image
    ? process.env.GATSBY_SITE_URL + image
    : defaultMetaImage
    ? process.env.GATSBY_SITE_URL + defaultMetaImage
    : null

  const pageTitle = `${title} | ${sitename}`
  const canonicalUrl = process.env.GATSBY_SITE_URL + location.pathname

  if (!ld) {
    const types = ["WebPage"]

    let faq = null

    if (data?.page?.content) {
      const faqModules = data.page.content.filter(
        module => module.__typename === "FaqModule"
      )

      if (faqModules.length > 0) {
        types.push("FaqPage")

        faq = faqModules.reduce((acc, faqModule) => {
          faqModule.questions.forEach(faq =>
            acc.push({
              "@type": "Question",
              name: faq.question,
              acceptedAnswer: {
                "@type": "Answer",
                text: faq.answer,
              },
            })
          )

          return acc
        }, [])
      }
    }

    /**
     * Get JSON LD
     */
    const microdata = new Microdata(canonicalUrl, {
      types,
      title,
      description,
      image: image ? process.env.GATSBY_SITE_URL + image : null,
    }).page()

    if (faq) {
      microdata.setMainEntity(faq)
    }

    ld = microdata.get()
  }

  return (
    <>
      <title>{pageTitle}</title>
      <meta
        name="robots"
        content={
          doNotIndex ? "noindex" : "max-image-preview:large, index, follow"
        }
      />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:type" content="website" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:card" content="summary" />
      {canonicalUrl && (
        <>
          <meta property="og:url" content={canonicalUrl} />
          <link rel="canonical" href={canonicalUrl} />
        </>
      )}
      {description && (
        <>
          <meta name="description" content={description} />
          <meta property="og:description" content={description} />
          <meta name="twitter:description" content={description} />
        </>
      )}
      {metaImage && (
        <>
          <meta property="og:image" content={metaImage} />
          <meta name="twitter:image" content={metaImage} />
        </>
      )}
      {ld && <script type="application/ld+json">{ld}</script>}
    </>
  )
}

export { Seo }
